
import React from 'react';
import { ENV } from '@/infrastructure/env-config';
import { MetricSubType } from '@/proto/metric';
import docLink from './docs';


/**
 * 这里放文案配置
 */
export default {
  hintDeviceRatio: '设备异常率 =  满足筛选条件的异常设备数（按设备ID去重） /  满足联网上报支持的筛选条件的联网设备数（按设备ID去重）',
  hintDeviceAvgRatio: '设备平均异常率 =  满足筛选条件的异常个例数 / 满足联网上报支持的筛选条件的联网设备数（按设备ID去重）',
  hintCountRatio: '次数异常率 =  满足筛选条件的异常个例数 / 满足筛选条件的启动次数。（当前启动次数的统计只支持时间范围和App版本两个筛选条件。）仅支持查看2023年7月29日之后的数据。',
  hintUserRatio: '人数异常率 =  满足筛选条件的异常用户数（按用户ID去重）/  满足联网上报支持的筛选条件的联网用户数（按用户ID去重）',
  hintLaunch: '从进程创建到进程退出计为一次启动。仅支持查看2023年7月29日之后的数据。',
  hintDeviceUv: '异常上报中，按设备ID去重',
  hintUserUv: '异常上报中，按用户ID去重',
  hintDauDeviceUv: '联网上报，按设备ID去重，当前只支持时间范围，APP版本，实验ID，业务下钻，BundleID，SDK版本等筛选字段的下钻。',
  noticeRequestURL: `https://api.wuji.qq.com/x/api/wuji_cache/object/?appid=${ENV.noticeDBAppId}&schemaid=${ENV.noticeDBSchemaId}&schemakey=${ENV.noticeDBSchemakey}&sort=_mtime&order=desc&filter=appVersion%%woa`,
  // subBrandText: process.env.APP_VERSION === 'global' ? '海外版' : '专业版',
  subBrandText: '专业版',
  disableVersionHelpText: 'Bugly小助手',
  importanceUnknownHelpText: 'Bugly小助手',
  memoryOptimizationHref: 'https://docs.bugly.woa.com/Android/memory/monitor#24-native%E5%86%85%E5%AD%98%E8%AF%A6%E6%83%85',
  defaultStateGroupLagRateTime: [
    {
      label: '卡顿耗时>=0.8s',
      subLabel: '默认阈值-单次卡顿耗时大于等于0.8秒',
      key: 'lag_rate_time_cost_level1',
    },
    {
      label: '卡顿耗时>=1.5s',
      subLabel: '默认阈值-单次卡顿耗时大于等于1.5秒',
      key: 'lag_rate_time_cost_level2',
    },
    {
      label: '卡顿耗时>=3s',
      subLabel: '默认阈值-单次卡顿耗时大于等于3秒',
      key: 'lag_rate_time_cost_level3',
    },
  ],
  defaultStateGroupCountTimeCost: [
    {
      label: '卡顿耗时>=0.8s',
      subLabel: '默认阈值-单次卡顿耗时大于等于0.8秒',
      key: 'lag_count_time_cost_level1',
    },
    {
      label: '卡顿耗时>=1.5s',
      subLabel: '默认阈值-单次卡顿耗时大于等于1.5秒',
      key: 'lag_count_time_cost_level2',
    },
    {
      label: '卡顿耗时>=3s',
      subLabel: '默认阈值-单次卡顿耗时大于等于3秒',
      key: 'lag_count_time_cost_level3',
    },
  ],
  subTypeCountRatio: [
    MetricSubType.SUB_TYPE_LAG_RATE_TIME_COST_LEVEL1,
    MetricSubType.SUB_TYPE_LAG_RATE_TIME_COST_LEVEL2,
    MetricSubType.SUB_TYPE_LAG_RATE_TIME_COST_LEVEL3,
  ],
  subTypeCount: [
    MetricSubType.SUB_TYPE_LAG_COUNT_TIME_COST_LEVEL1,
    MetricSubType.SUB_TYPE_LAG_COUNT_TIME_COST_LEVEL2,
    MetricSubType.SUB_TYPE_LAG_COUNT_TIME_COST_LEVEL3,
  ],
  lagRateTimeCostKeys: ['>=0.8s', '>=1.5s', '>=3.0s'],

  // tips
  // tips
  enumFilterTips: <span>枚举类型筛选项，支持输入多个关键字，详细<a target={'_blank'} href={docLink.searchDoc}>查看指引</a>。</span>,
  specialFilterTips: <span>特殊类型筛选项，支持输入多个关键字，详细<a target={'_blank'} href={docLink.searchDoc}>查看指引</a>。</span>,
};
